import React from "react";
import { Navigate } from "react-router-dom";
import Spinner from "./Spinner";

const ProtectedRoute = ({ element: Component, user, allowedRoles }) => {
  // Mientras se obtiene el usuario (user no definido)
  if (!user) {
    return <Spinner />; // Puedes mostrar un loader aquí
  }

  // Verifica si el rol del usuario está permitido
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/rides" replace />;
  }

  // Si todo está bien, renderiza el componente solicitado
  return <Component />;
};

export default ProtectedRoute;
